import { render, staticRenderFns } from "./TypeTable.vue?vue&type=template&id=637493b4&scoped=true"
import script from "./TypeTable.vue?vue&type=script&lang=js"
export * from "./TypeTable.vue?vue&type=script&lang=js"
import style0 from "./TypeTable.vue?vue&type=style&index=0&id=637493b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637493b4",
  null
  
)

export default component.exports